import React, { useState, useRef } from "react";
import intl from "react-intl-universal";

import { Confirm } from "./Confirm";
import { useSse } from "../hooks/useSse";

export const UpdateDialog = () => {

    const checksumRef = useRef(null);
    const [show, setShow] = useState(false);

    useSse("BUNDLE_CHECKSUM", checksum => {
        if (checksumRef.current === null) {
            checksumRef.current = checksum;
        } else if (checksum !== checksumRef.current) {
            setShow(true);
        }
    });

    return (
        <>
            {show &&
                <Confirm
                    confirmButtonOnly={true}
                    title={intl.get("update.title")}
                    body={intl.get("update.body")}
                    confirm={intl.get("update.confirm")}
                    onConfirm={() => location.reload()}
                    onClose={() => location.reload()} />
            }
        </>
    );
};